import styled from 'styled-components'
import { theme } from 'utils/theme'

export const defaultColor = theme.colors.orange

export const IconContainer = styled.div`
  height: ${({ height }) => height};
  width: ${({ width }) => width};
  position: relative;
  top: ${props => props.position};

  svg {
    height: ${({ height }) => height};
    width: ${({ width }) => width};
    path {
      fill: ${({ color }) => color};
    }
  }
  &:hover {
    .tooltip {
      display: block;
    }
  }
`

export const Tooltip = styled.div`
  display: none;
  background-color: ${theme.colors.white};
  border: 1px solid ${theme.colors.background};
  padding: 10px;
  text-transform: none;
  position: absolute;
  right: -100px;
  top: 25px;
  width: 320px;
  z-index: 9;
  border-radius: 5px;
`
